/**
 * atonce/service-stages — stan przyklejenia lewej kolumny (akcept Usługi: data-przyklejony="tak|nie"). Gdy .ss__head jest `sticky`
 * i stoi niżej niż jego miejsce w przepływie (góra kontenera .ss__switch), dostaje data-pinned="tak": blok tytułu unosi się o 33 px,
 * a ikona etapu wjeżdża (SCSS). Liczone w rAF przy przewijaniu i zmianie rozmiaru; poniżej 900 px kontenera kolumna nie jest sticky → „nie”.
 */
( function () {
	const heads = [ ...document.querySelectorAll( '.ss__head' ) ];
	if ( ! heads.length ) {
		return;
	}
	let raf = 0;
	const paint = () => {
		raf = 0;
		heads.forEach( ( head ) => {
			const sticky = getComputedStyle( head ).position === 'sticky';
			const pinned = sticky && head.getBoundingClientRect().top - head.parentElement.getBoundingClientRect().top > 1;
			head.setAttribute( 'data-pinned', pinned ? 'tak' : 'nie' );
		} );
	};
	const schedule = () => {
		if ( ! raf ) {
			raf = requestAnimationFrame( paint );
		}
	};
	window.addEventListener( 'scroll', schedule, { passive: true } );
	window.addEventListener( 'resize', schedule );
	paint();
	// Ikona etapu (makieta online, EO): wjazd 32 px → 0 i krycie 0 → 1 raz, gdy ikona wejdzie w dolne 85 % okna (threshold 0); bez ruchu od razu widoczna.
	const icons = document.querySelectorAll( '.ss__icon' );
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches || ! ( 'IntersectionObserver' in window ) ) {
		icons.forEach( ( i ) => i.setAttribute( 'data-in', 'tak' ) );
		return;
	}
	const io = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( e ) => {
			if ( e.isIntersecting ) {
				e.target.setAttribute( 'data-in', 'tak' );
				io.unobserve( e.target );
			}
		} );
	}, { rootMargin: '0px 0px -15% 0px', threshold: 0 } );
	icons.forEach( ( i ) => io.observe( i ) );
} )();
